import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@fuse/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { VibeSelectControlModule } from '../vibe-select-control/vibe-select-control.module';
import { MultiChoiceOptionsComponent } from './multi-choice-options.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    TranslateModule,
    FormsModule,
    VibeSelectControlModule,
    DatePickerModule
  ],
  exports: [MultiChoiceOptionsComponent],
  declarations: [MultiChoiceOptionsComponent],
  entryComponents: [
    MultiChoiceOptionsComponent
  ]
})
export class MultiChoiceOptionsModule { }
